import PropTypes from 'prop-types';
import classNames from 'classnames';

import TickIcon from '../../components/shared-components/icons/TickIcon';

import {
    getFormationImage,
    handleFormationImageError
} from '../../helpers/formations';

import styleSheet from '../styles/formationModal.module.scss';

const styles = styleSheet.locals || {};

/**
 * FormationSelector component displays a list of formations for selection.
 *
 * @param {object} props - The props for the FormationSelector component.
 * @param {Array} props.formations - Array of formation objects.
 * @param {*} props.selectedFormation - Currently selected formation.
 * @param {Function} props.onSelect - Callback when a formation is selected.
 * @param {Function} props.onClose - Callback when the selector is closed.
 * @returns {Element} The rendered FormationSelector component.
 */
function FormationSelector({
    formations,
    selectedFormation,
    onSelect,
    onClose
}) {
    return (
        <>
            <style>{styleSheet.toString()}</style>
            <div className={styles.formationModal} part="ts-formation-modal">
                <div className={styles.formationModalWrapper}>
                    <div className={styles.formationModalHeader}>
                        <div className={styles.formationModalTitle}>
                            Select formation
                        </div>
                        <button
                            className={styles.formationModalCancel}
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className={styles.formationModalFormationList}>
                        {formations.map((formation) => {
                            const isSelected =
                                formation.name === selectedFormation;

                            const btnClass = classNames(
                                styles.formationModalFormation,
                                {
                                    [styles.formationModalFormationSelected]:
                                        isSelected
                                }
                            );

                            return (
                                <button
                                    key={formation.id || formation.name}
                                    className={btnClass}
                                    onClick={() =>
                                        onSelect(formation.id || formation.name)
                                    }
                                >
                                    <div
                                        className={
                                            styles.formationModalFormationNameWrapper
                                        }
                                    >
                                        <span
                                            className={
                                                styles.formationModalFormationName
                                            }
                                        >
                                            {formation.name}
                                        </span>
                                        {isSelected && (
                                            <span
                                                className={
                                                    styles.formationModalTick
                                                }
                                            >
                                                <TickIcon />
                                            </span>
                                        )}
                                    </div>

                                    <img
                                        src={getFormationImage(formation)}
                                        alt={formation.name || ''}
                                        className={
                                            styles.formationModalFormationImage
                                        }
                                        onError={(event) =>
                                            handleFormationImageError(
                                                event,
                                                formation
                                            )
                                        }
                                    />
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}

FormationSelector.propTypes = {
    formations: PropTypes.array.isRequired,
    selectedFormation: PropTypes.any,
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

export default FormationSelector;
